import { jsx as _jsx } from "react/jsx-runtime";
import { NetworkRenderer } from 'components/NetworkRenderer/NetworkRenderer';
import { DESTINATION_CHAINS } from './TransferPage.constants';
export const generateDestinationOptions = () => DESTINATION_CHAINS.sort(() => Math.random() - 0.5).map(chain => ({
    label: _jsx(NetworkRenderer, { network: chain }),
    value: chain.id,
}));
